// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * NaqdPay brand palette + PrimeReact Lara variable alignment.
 * Imported after \`primereact/.../theme.css\` so overrides apply globally.
 */
:root {
  /* Canonical palette */
  --color-primary: #8f653a;
  --color-primary-dark: #68472c;
  --color-primary-light: #b98b5d;
  --color-soft-beige: #e8d9c8;
  --color-background: #f8f4ef;
  --color-surface: #ffffff;
  --color-text: #2f241c;
  --color-text-muted: #74665a;

  /* Brand scale (aligned with Prime primary scale) */
  --brand-900: #39281b;
  --brand-800: #4d3522;
  --brand-700: #624328;
  --brand-600: #79532f;
  --brand-500: #8f653a;
  --brand-400: #ad8054;
  --brand-300: #c9a47f;
  --brand-200: #dec8b1;
  --brand-100: #eee2d5;
  --brand-50: #faf7f3;

  /* Text */
  --text-primary: var(--color-text);
  --text-secondary: var(--color-text-muted);
  --text-muted: var(--color-text-muted);
  --text-on-brand: #ffffff;

  /* Background / surfaces */
  --bg-page: var(--color-background);
  --bg-card: var(--color-surface);
  --bg-soft: var(--color-soft-beige);
  --border: #d9c9b8;

  /* Status */
  --success: #22c55e;
  --warning: #f59e0b;
  --danger: #ef4444;
  --info: var(--brand-600);

  /* Semantic soft tints — PrimeReact hover/active/message backgrounds */
  --primary-tint-04: color-mix(in srgb, var(--primary-color) 4%, transparent);
  --primary-tint-12: color-mix(in srgb, var(--primary-color) 12%, transparent);
  --primary-tint-16: color-mix(in srgb, var(--primary-color) 16%, transparent);
  --primary-tint-70: color-mix(in srgb, var(--brand-100) 70%, transparent);
  --danger-tint-04: color-mix(in srgb, var(--danger) 4%, transparent);
  --danger-tint-12: color-mix(in srgb, var(--danger) 12%, transparent);
  --danger-tint-16: color-mix(in srgb, var(--danger) 16%, transparent);
  --danger-tint-20: color-mix(in srgb, var(--danger) 20%, transparent);
  --danger-tint-32: color-mix(in srgb, var(--danger) 32%, transparent);
  --danger-tint-38: color-mix(in srgb, var(--danger) 38%, transparent);
  --danger-tint-70: color-mix(in srgb, var(--danger) 12%, var(--color-surface) 88%);
  --success-tint-04: color-mix(in srgb, var(--success) 4%, transparent);
  --success-tint-12: color-mix(in srgb, var(--success) 12%, transparent);
  --success-tint-16: color-mix(in srgb, var(--success) 16%, transparent);
  --success-tint-20: color-mix(in srgb, var(--success) 20%, transparent);
  --success-tint-32: color-mix(in srgb, var(--success) 32%, transparent);
  --success-tint-35: color-mix(in srgb, var(--success) 35%, transparent);
  --success-tint-40: color-mix(in srgb, var(--success) 40%, transparent);
  --success-tint-70: color-mix(in srgb, var(--success) 12%, var(--color-surface) 88%);
  --warning-tint-04: color-mix(in srgb, var(--warning) 4%, transparent);
  --warning-tint-16: color-mix(in srgb, var(--warning) 16%, transparent);
  --warning-tint-70: color-mix(in srgb, var(--warning) 12%, var(--color-surface) 88%);
  --info-tint-04: color-mix(in srgb, var(--primary-color) 4%, transparent);
  --info-tint-16: color-mix(in srgb, var(--primary-color) 16%, transparent);
  --secondary-tint-04: color-mix(in srgb, var(--text-muted) 4%, transparent);
  --secondary-tint-16: color-mix(in srgb, var(--text-muted) 16%, transparent);
  --help-tint-04: color-mix(in srgb, var(--brand-400) 4%, transparent);
  --help-tint-14: color-mix(in srgb, var(--brand-600) 14%, transparent);
  --help-tint-16: color-mix(in srgb, var(--brand-400) 16%, transparent);
  --brand-shadow-soft: color-mix(in srgb, var(--brand-800) 10%, transparent);

  /* Layout / marketing surfaces */
  --gradient-brand-hero: linear-gradient(135deg, var(--brand-800) 0%, var(--brand-900) 100%);
  --gradient-brand-chat: linear-gradient(135deg, var(--brand-600) 0%, var(--brand-800) 100%);
  --gradient-brand-soft: linear-gradient(135deg, var(--brand-50) 0%, var(--bg-card) 100%);
  --gradient-brand-action: linear-gradient(135deg, var(--brand-700) 0%, var(--brand-600) 100%);

  /* ── PrimeReact Lara (light) — map to brand & semantics ───────────── */
  --primary-color: #8f653a;
  --primary-color-text: #ffffff;

  --primary-50: #faf7f3;
  --primary-100: #eee2d5;
  --primary-200: #dec8b1;
  --primary-300: #c9a47f;
  --primary-400: #ad8054;
  --primary-500: #8f653a;
  --primary-600: #79532f;
  --primary-700: #624328;
  --primary-800: #4d3522;
  --primary-900: #39281b;

  --text-color: var(--text-primary);
  --text-color-secondary: var(--text-secondary);

  --surface-ground: var(--bg-page);
  --surface-section: var(--bg-card);
  --surface-card: var(--bg-card);
  --surface-overlay: var(--bg-card);
  --surface-border: var(--border);
  --surface-hover: color-mix(in srgb, var(--brand-600) 8%, var(--bg-card));
  --surface-900: var(--text-primary);

  --highlight-bg: rgba(143, 101, 58, 0.18);
  --highlight-text-color: #ffffff;

  --focus-ring-color: rgba(143, 101, 58, 0.25);
  --focus-ring: 0 0 0 0.2rem rgba(143, 101, 58, 0.25);

  /* Prime palette “blue” scale → brand (components referencing --blue-*) */
  --blue-50: var(--brand-50);
  --blue-100: var(--brand-100);
  --blue-200: var(--brand-200);
  --blue-300: var(--brand-300);
  --blue-400: var(--brand-400);
  --blue-500: var(--brand-500);
  --blue-600: var(--brand-600);
  --blue-700: var(--brand-700);
  --blue-800: var(--brand-800);
  --blue-900: var(--brand-900);
}

/* PrimeReact info surfaces still ship with blue tints in Lara theme.css */
.p-inline-message.p-inline-message-info {
  background: var(--primary-tint-70) !important;
  border-color: var(--primary-color) !important;
  color: var(--brand-800) !important;
}

.p-inline-message.p-inline-message-info .p-inline-message-icon {
  color: var(--brand-800) !important;
}

.p-inline-message.p-inline-message-success {
  background: var(--success-tint-70) !important;
  border-color: var(--success) !important;
  color: var(--success) !important;
}

.p-inline-message.p-inline-message-success .p-inline-message-icon {
  color: var(--success) !important;
}

.p-inline-message.p-inline-message-warn {
  background: var(--warning-tint-70) !important;
  border-color: var(--warning) !important;
  color: var(--warning) !important;
}

.p-inline-message.p-inline-message-warn .p-inline-message-icon {
  color: var(--warning) !important;
}

.p-inline-message.p-inline-message-error {
  background: var(--danger-tint-70) !important;
  border-color: var(--danger) !important;
  color: var(--danger) !important;
}

.p-inline-message.p-inline-message-error .p-inline-message-icon {
  color: var(--danger) !important;
}

.p-message.p-message-info {
  background: var(--primary-tint-70) !important;
  border-color: var(--primary-color) !important;
  color: var(--brand-800) !important;
}

.p-message.p-message-info .p-message-icon,
.p-message.p-message-info .p-message-close {
  color: var(--brand-800) !important;
}

.p-message.p-message-success {
  background: var(--success-tint-70) !important;
  border-color: var(--success) !important;
  color: var(--success) !important;
}

.p-message.p-message-success .p-message-icon,
.p-message.p-message-success .p-message-close {
  color: var(--success) !important;
}

.p-message.p-message-warn {
  background: var(--warning-tint-70) !important;
  border-color: var(--warning) !important;
  color: var(--warning) !important;
}

.p-message.p-message-warn .p-message-icon,
.p-message.p-message-warn .p-message-close {
  color: var(--warning) !important;
}

.p-message.p-message-error {
  background: var(--danger-tint-70) !important;
  border-color: var(--danger) !important;
  color: var(--danger) !important;
}

.p-message.p-message-error .p-message-icon,
.p-message.p-message-error .p-message-close {
  color: var(--danger) !important;
}

.p-tag.p-tag-info,
.p-badge.p-badge-info {
  background: var(--primary-color) !important;
}

.p-button.p-button-info {
  background: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.p-button.p-button-info:enabled:hover {
  background: var(--primary-700) !important;
  border-color: var(--primary-700) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/brand-tokens.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;;EAE3B,mDAAmD;EACnD,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;;EAEnB,SAAS;EACT,iCAAiC;EACjC,yCAAyC;EACzC,qCAAqC;EACrC,wBAAwB;;EAExB,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;EAClC,iBAAiB;;EAEjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;;EAExB,sEAAsE;EACtE,2EAA2E;EAC3E,4EAA4E;EAC5E,4EAA4E;EAC5E,wEAAwE;EACxE,mEAAmE;EACnE,oEAAoE;EACpE,oEAAoE;EACpE,oEAAoE;EACpE,oEAAoE;EACpE,oEAAoE;EACpE,iFAAiF;EACjF,qEAAqE;EACrE,sEAAsE;EACtE,sEAAsE;EACtE,sEAAsE;EACtE,sEAAsE;EACtE,sEAAsE;EACtE,sEAAsE;EACtE,mFAAmF;EACnF,qEAAqE;EACrE,sEAAsE;EACtE,mFAAmF;EACnF,wEAAwE;EACxE,yEAAyE;EACzE,0EAA0E;EAC1E,2EAA2E;EAC3E,oEAAoE;EACpE,qEAAqE;EACrE,qEAAqE;EACrE,0EAA0E;;EAE1E,gCAAgC;EAChC,0FAA0F;EAC1F,0FAA0F;EAC1F,uFAAuF;EACvF,4FAA4F;;EAE5F,wEAAwE;EACxE,wBAAwB;EACxB,6BAA6B;;EAE7B,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,iCAAiC;EACjC,6CAA6C;;EAE7C,gCAAgC;EAChC,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,wEAAwE;EACxE,kCAAkC;;EAElC,wCAAwC;EACxC,+BAA+B;;EAE/B,4CAA4C;EAC5C,mDAAmD;;EAEnD,yEAAyE;EACzE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,0EAA0E;AAC1E;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C","sourcesContent":["/**\n * NaqdPay brand palette + PrimeReact Lara variable alignment.\n * Imported after `primereact/.../theme.css` so overrides apply globally.\n */\n:root {\n  /* Canonical palette */\n  --color-primary: #8f653a;\n  --color-primary-dark: #68472c;\n  --color-primary-light: #b98b5d;\n  --color-soft-beige: #e8d9c8;\n  --color-background: #f8f4ef;\n  --color-surface: #ffffff;\n  --color-text: #2f241c;\n  --color-text-muted: #74665a;\n\n  /* Brand scale (aligned with Prime primary scale) */\n  --brand-900: #39281b;\n  --brand-800: #4d3522;\n  --brand-700: #624328;\n  --brand-600: #79532f;\n  --brand-500: #8f653a;\n  --brand-400: #ad8054;\n  --brand-300: #c9a47f;\n  --brand-200: #dec8b1;\n  --brand-100: #eee2d5;\n  --brand-50: #faf7f3;\n\n  /* Text */\n  --text-primary: var(--color-text);\n  --text-secondary: var(--color-text-muted);\n  --text-muted: var(--color-text-muted);\n  --text-on-brand: #ffffff;\n\n  /* Background / surfaces */\n  --bg-page: var(--color-background);\n  --bg-card: var(--color-surface);\n  --bg-soft: var(--color-soft-beige);\n  --border: #d9c9b8;\n\n  /* Status */\n  --success: #22c55e;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n  --info: var(--brand-600);\n\n  /* Semantic soft tints — PrimeReact hover/active/message backgrounds */\n  --primary-tint-04: color-mix(in srgb, var(--primary-color) 4%, transparent);\n  --primary-tint-12: color-mix(in srgb, var(--primary-color) 12%, transparent);\n  --primary-tint-16: color-mix(in srgb, var(--primary-color) 16%, transparent);\n  --primary-tint-70: color-mix(in srgb, var(--brand-100) 70%, transparent);\n  --danger-tint-04: color-mix(in srgb, var(--danger) 4%, transparent);\n  --danger-tint-12: color-mix(in srgb, var(--danger) 12%, transparent);\n  --danger-tint-16: color-mix(in srgb, var(--danger) 16%, transparent);\n  --danger-tint-20: color-mix(in srgb, var(--danger) 20%, transparent);\n  --danger-tint-32: color-mix(in srgb, var(--danger) 32%, transparent);\n  --danger-tint-38: color-mix(in srgb, var(--danger) 38%, transparent);\n  --danger-tint-70: color-mix(in srgb, var(--danger) 12%, var(--color-surface) 88%);\n  --success-tint-04: color-mix(in srgb, var(--success) 4%, transparent);\n  --success-tint-12: color-mix(in srgb, var(--success) 12%, transparent);\n  --success-tint-16: color-mix(in srgb, var(--success) 16%, transparent);\n  --success-tint-20: color-mix(in srgb, var(--success) 20%, transparent);\n  --success-tint-32: color-mix(in srgb, var(--success) 32%, transparent);\n  --success-tint-35: color-mix(in srgb, var(--success) 35%, transparent);\n  --success-tint-40: color-mix(in srgb, var(--success) 40%, transparent);\n  --success-tint-70: color-mix(in srgb, var(--success) 12%, var(--color-surface) 88%);\n  --warning-tint-04: color-mix(in srgb, var(--warning) 4%, transparent);\n  --warning-tint-16: color-mix(in srgb, var(--warning) 16%, transparent);\n  --warning-tint-70: color-mix(in srgb, var(--warning) 12%, var(--color-surface) 88%);\n  --info-tint-04: color-mix(in srgb, var(--primary-color) 4%, transparent);\n  --info-tint-16: color-mix(in srgb, var(--primary-color) 16%, transparent);\n  --secondary-tint-04: color-mix(in srgb, var(--text-muted) 4%, transparent);\n  --secondary-tint-16: color-mix(in srgb, var(--text-muted) 16%, transparent);\n  --help-tint-04: color-mix(in srgb, var(--brand-400) 4%, transparent);\n  --help-tint-14: color-mix(in srgb, var(--brand-600) 14%, transparent);\n  --help-tint-16: color-mix(in srgb, var(--brand-400) 16%, transparent);\n  --brand-shadow-soft: color-mix(in srgb, var(--brand-800) 10%, transparent);\n\n  /* Layout / marketing surfaces */\n  --gradient-brand-hero: linear-gradient(135deg, var(--brand-800) 0%, var(--brand-900) 100%);\n  --gradient-brand-chat: linear-gradient(135deg, var(--brand-600) 0%, var(--brand-800) 100%);\n  --gradient-brand-soft: linear-gradient(135deg, var(--brand-50) 0%, var(--bg-card) 100%);\n  --gradient-brand-action: linear-gradient(135deg, var(--brand-700) 0%, var(--brand-600) 100%);\n\n  /* ── PrimeReact Lara (light) — map to brand & semantics ───────────── */\n  --primary-color: #8f653a;\n  --primary-color-text: #ffffff;\n\n  --primary-50: #faf7f3;\n  --primary-100: #eee2d5;\n  --primary-200: #dec8b1;\n  --primary-300: #c9a47f;\n  --primary-400: #ad8054;\n  --primary-500: #8f653a;\n  --primary-600: #79532f;\n  --primary-700: #624328;\n  --primary-800: #4d3522;\n  --primary-900: #39281b;\n\n  --text-color: var(--text-primary);\n  --text-color-secondary: var(--text-secondary);\n\n  --surface-ground: var(--bg-page);\n  --surface-section: var(--bg-card);\n  --surface-card: var(--bg-card);\n  --surface-overlay: var(--bg-card);\n  --surface-border: var(--border);\n  --surface-hover: color-mix(in srgb, var(--brand-600) 8%, var(--bg-card));\n  --surface-900: var(--text-primary);\n\n  --highlight-bg: rgba(143, 101, 58, 0.18);\n  --highlight-text-color: #ffffff;\n\n  --focus-ring-color: rgba(143, 101, 58, 0.25);\n  --focus-ring: 0 0 0 0.2rem rgba(143, 101, 58, 0.25);\n\n  /* Prime palette “blue” scale → brand (components referencing --blue-*) */\n  --blue-50: var(--brand-50);\n  --blue-100: var(--brand-100);\n  --blue-200: var(--brand-200);\n  --blue-300: var(--brand-300);\n  --blue-400: var(--brand-400);\n  --blue-500: var(--brand-500);\n  --blue-600: var(--brand-600);\n  --blue-700: var(--brand-700);\n  --blue-800: var(--brand-800);\n  --blue-900: var(--brand-900);\n}\n\n/* PrimeReact info surfaces still ship with blue tints in Lara theme.css */\n.p-inline-message.p-inline-message-info {\n  background: var(--primary-tint-70) !important;\n  border-color: var(--primary-color) !important;\n  color: var(--brand-800) !important;\n}\n\n.p-inline-message.p-inline-message-info .p-inline-message-icon {\n  color: var(--brand-800) !important;\n}\n\n.p-inline-message.p-inline-message-success {\n  background: var(--success-tint-70) !important;\n  border-color: var(--success) !important;\n  color: var(--success) !important;\n}\n\n.p-inline-message.p-inline-message-success .p-inline-message-icon {\n  color: var(--success) !important;\n}\n\n.p-inline-message.p-inline-message-warn {\n  background: var(--warning-tint-70) !important;\n  border-color: var(--warning) !important;\n  color: var(--warning) !important;\n}\n\n.p-inline-message.p-inline-message-warn .p-inline-message-icon {\n  color: var(--warning) !important;\n}\n\n.p-inline-message.p-inline-message-error {\n  background: var(--danger-tint-70) !important;\n  border-color: var(--danger) !important;\n  color: var(--danger) !important;\n}\n\n.p-inline-message.p-inline-message-error .p-inline-message-icon {\n  color: var(--danger) !important;\n}\n\n.p-message.p-message-info {\n  background: var(--primary-tint-70) !important;\n  border-color: var(--primary-color) !important;\n  color: var(--brand-800) !important;\n}\n\n.p-message.p-message-info .p-message-icon,\n.p-message.p-message-info .p-message-close {\n  color: var(--brand-800) !important;\n}\n\n.p-message.p-message-success {\n  background: var(--success-tint-70) !important;\n  border-color: var(--success) !important;\n  color: var(--success) !important;\n}\n\n.p-message.p-message-success .p-message-icon,\n.p-message.p-message-success .p-message-close {\n  color: var(--success) !important;\n}\n\n.p-message.p-message-warn {\n  background: var(--warning-tint-70) !important;\n  border-color: var(--warning) !important;\n  color: var(--warning) !important;\n}\n\n.p-message.p-message-warn .p-message-icon,\n.p-message.p-message-warn .p-message-close {\n  color: var(--warning) !important;\n}\n\n.p-message.p-message-error {\n  background: var(--danger-tint-70) !important;\n  border-color: var(--danger) !important;\n  color: var(--danger) !important;\n}\n\n.p-message.p-message-error .p-message-icon,\n.p-message.p-message-error .p-message-close {\n  color: var(--danger) !important;\n}\n\n.p-tag.p-tag-info,\n.p-badge.p-badge-info {\n  background: var(--primary-color) !important;\n}\n\n.p-button.p-button-info {\n  background: var(--primary-color) !important;\n  border-color: var(--primary-color) !important;\n}\n\n.p-button.p-button-info:enabled:hover {\n  background: var(--primary-700) !important;\n  border-color: var(--primary-700) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
